import { HardTermination } from '../shared';

const NoService = () => (
  <HardTermination
    title="Unfortunately, we can’t provide the level of care you need at this time"
    body="We hope to be able to in the future, so please check back."
    shouldShowWhatWeCantTreatDialog
  />
);

export default NoService;
